export const hasIP = (server, ip) => server.publicIP === ip || server.privateIP === ip;
export const hasRole = (server, role) => (server.roles || []).find(r => r === role);